import type { FC } from 'react';

import { SettingsConnected } from '../../../settings/SettingsConnected';

export const NavPageSettingsConnected: FC = () => <SettingsConnected />;
